import { render, staticRenderFns } from "./saleReturn.vue?vue&type=template&id=05677ef4"
import script from "./saleReturn.vue?vue&type=script&lang=js"
export * from "./saleReturn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports